import PropTypes from 'prop-types';

import { loginUrl, registerUrl } from '../../utils';
import BigHeading from '../BigHeading';
import Button from '../Button';
import VerticalSpacing from '../VerticalSpacing';
import styles from './styles.scss';

Paywall.propTypes = {
  reason: PropTypes.oneOf(['not_logged_in']).isRequired,
};

export default function Paywall({ reason }) {
  if (reason !== 'not_logged_in') {
    console.error(`Unexpected paywall reason ${reason}`);
    return null;
  }

  return (
    <div className={styles.root}>
      <VerticalSpacing between={2} center className={styles.loginWrapper}>
        <p className={styles.loginMessage}>
          Du behöver vara medlem på Överodds för att läsa det här innehållet.
          Har du ett konto hos TR Media? Använd då samma inloggningsuppgifter
          även på Överodds.
        </p>
        <div className={styles.buttonWrapper}>
          <Button to={loginUrl()} variant="regular-lg" block>
            Logga in
          </Button>
        </div>
        <div className={styles.or}>
          <hr className={styles.orDivider} />
          <span className={styles.orText}>eller</span>
          <hr className={styles.orDivider} />
        </div>
      </VerticalSpacing>
      <VerticalSpacing between={1} center className={styles.ctaWrapper}>
        <BigHeading level={4} className={styles.ctaHeader}>
          Överodds är helt gratis!
        </BigHeading>
        <p className={styles.ctaMessage}>
          Logga in eller skapa ett konto på TR Media för att läsa alla analyser,
          speltips, bloggar, spelskolor m.m. helt gratis
        </p>
        <div className={styles.buttonWrapper}>
          <Button to={registerUrl()} variant="white-lg" block>
            Registrera dig
          </Button>
        </div>
      </VerticalSpacing>
    </div>
  );
}
